import type { LocaleResponse } from '@/types/textCms';

import en from './en.json';

const locales: Record<string, LocaleResponse> = {
  en: en as LocaleResponse,
};

export const AVAILABLE_LOCALES = Object.keys(locales) as string[];

export function getLocaleTexts(locale: string): LocaleResponse | undefined {
  const normalized = locale.toLowerCase().split('-')[0];
  return locales[normalized];
}

export function loadLocaleTexts(locale: string): Promise<LocaleResponse | undefined> {
  return Promise.resolve(getLocaleTexts(locale));
}

function getAllPaths(obj: Record<string, unknown>, prefix = ''): string[] {
  const paths: string[] = [];
  for (const [key, value] of Object.entries(obj)) {
    const path = prefix ? `${prefix}.${key}` : key;
    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      paths.push(...getAllPaths(value as Record<string, unknown>, path));
    } else {
      paths.push(path);
    }
  }
  return paths;
}

let shortKeyToFullPath: Record<string, string> | null = null;

function getShortKeyToFullPath(): Record<string, string> {
  if (shortKeyToFullPath) return shortKeyToFullPath;
  const data = getLocaleTexts('en')?.texts;
  if (!data || typeof data !== 'object') {
    shortKeyToFullPath = {};
    return shortKeyToFullPath;
  }
  shortKeyToFullPath = {};
  const paths = getAllPaths(data as Record<string, unknown>);
  for (const path of paths) {
    const shortKey = path.split('.').pop() ?? path;
    if (!(shortKey in shortKeyToFullPath)) shortKeyToFullPath[shortKey] = path;
  }
  return shortKeyToFullPath;
}

export function expandFlatCmsTexts(flat: Record<string, unknown>): Record<string, unknown> {
  const keyMap = getShortKeyToFullPath();
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(flat)) {
    const fullPath = key.includes('.') ? key : (keyMap[key] ?? key);
    const parts = fullPath.split('.');
    let current = result;
    for (let i = 0; i < parts.length - 1; i++) {
      const part = parts[i];
      if (!(part in current) || typeof current[part] !== 'object') {
        current[part] = {};
      }
      current = current[part] as Record<string, unknown>;
    }
    current[parts[parts.length - 1]] = value;
  }
  return result;
}

export default locales;
